import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';

// Inputs
import { TextInputField } from '../../../helpers'
import { Toast } from 'primereact/toast';


// redux
import { raiseToast } from '../../../services/redux/reducers/toast/toast';

const CNSellerPOPIPunchItems = (props) => {

    const dispatch = useDispatch()

    const { PIPunchItem, buyerInvoiceItem, selectedBuyerInvoiceItemsPIPunch } = props

    useEffect(() => {

    })

    const handleSpoProductPIPunchCreditNoteQty = (event, selectedBuyerInvoiceItemId, selectedSellerPIPunchItemId ) => {
        event.stopPropagation()

        const relatedBuyerInvoiceItem = selectedBuyerInvoiceItemsPIPunch.find(eachBuyerInvoiceItem => eachBuyerInvoiceItem.buyerInvoiceItemId == selectedBuyerInvoiceItemId)

        if (relatedBuyerInvoiceItem) {

            let relatedSellerPOItem = relatedBuyerInvoiceItem?.sellerPOItems?.find(eachSellerPOItem =>
                eachSellerPOItem.piPunchItems?.some(eachPIPunchItem =>
                    eachPIPunchItem.sellerPIPunchItemId === selectedSellerPIPunchItemId
                )
            )

            let relatedSellerPIPunchItem = relatedSellerPOItem?.piPunchItems?.find(eachPIPunchItem =>
                eachPIPunchItem.sellerPIPunchItemId === selectedSellerPIPunchItemId
            )

            if(relatedSellerPIPunchItem){
                const regex = /^\d*\.?\d{0,3}$/;

                if (!regex.test(event.target.value)) {
                    return dispatch(raiseToast({ severity: 'warn', detail: `Only 3 decimal values are allowed`, life: 3000 }))
                }

                if (relatedSellerPIPunchItem.totalPIPunchItemCreditNoteQty >= event.target.value) {
                    relatedSellerPIPunchItem["spoProductPiPunchCreditNoteQty"] = event.target.value
                } else {
                    relatedSellerPIPunchItem["spoProductPiPunchCreditNoteQty"] = 0
                    dispatch(raiseToast({ severity: 'warn', summary: 'Warning Message', detail: `Only ${relatedSellerPIPunchItem.totalPIPunchItemCreditNoteQty} pi punch quantity available`, life: 3000 }))
                }


            }
        }

        props.setSelectedBuyerInvoiceItemsPIPunch([...selectedBuyerInvoiceItemsPIPunch])
    }
    

    return (
        <div className='flex flex-row col-12 pb-0'>
            <div className='flex flex-row col-12 md:col-4 lg:col-4  align-items-center justify-content-end' >
                <span>PI Punch No: {PIPunchItem.sellerPIPunchItemId} {`(${PIPunchItem.sellerPINumber})` }</span>
            </div>
            <div className='flex col-12 md:col-3 lg:col-2 h-3rem pr-0'>
                <TextInputField 
                    value = {PIPunchItem.spoProductPiPunchCreditNoteQty}
                    name="spoProductPiPunchCreditNoteQty"
                    keyfilter='pnum'
                    placeholder="Enter Qty"
                    onChange={(event) => handleSpoProductPIPunchCreditNoteQty(event, buyerInvoiceItem.buyerInvoiceItemId, PIPunchItem.sellerPIPunchItemId)}
                />
            </div>
            <div className=" flex flex-row col-12 md:col-4 lg:col-4 align-items-center" style={{ color: "#9E9E9E" }}>
                (Available Qty: <span>{PIPunchItem.totalPIPunchItemCreditNoteQty}</span>)
            </div>
        </div>
    )
}

export default CNSellerPOPIPunchItems